<template>
<ContentHeader />
<div class="container" style="max-height:100%;overflow:hidden;">
   <div class="row">
      <div class="col-sm-12">
         <div class="card">
            <div class="card-body chat-page p-0">
               <div class="chat-data-block">
                  <div class="row">
                     <div class="col-lg-3 chat-data-left scroller">
                        <div class="chat-search pt-3 ps-3">
                           <div class="d-flex align-items-center">
                              <div class="chat-profile me-3">
                                 <img :src="avatar" alt="chat-user" class="avatar-60 ">
                              </div>
                              <div class="chat-caption">
                                 <h5 class="mb-0">{{f_name}}</h5>
                                 <p class="m-0">Online</p>
                              </div>
                              <button type="submit" class="close-btn-res p-3"><i class="ri-close-fill"></i></button>
                           </div>
                           <div id="user-detail-popup" class="scroller">
                              <div class="user-profile">
                                 <button type="submit" class="close-popup p-3"><i class="ri-close-fill"></i></button>
                                 <div class="user text-center mb-4">
                                    <a class="avatar m-0">
                                    <img :src="avatar" alt="avatar" style="width:100%;">
                                    </a>
                                    <div class="user-name mt-4">
                                       <h4 class="text-center">{{f_name}} {{l_name}}</h4>
                                    </div>
                                    <div class="user-desc">
                                       <p class="text-center">(Me)</p>
                                    </div>
                                 </div>
                                 <hr>
                                 <div class="user-detail text-left mt-4 ps-4 pe-4">
                                    <h5 class="mt-4 mb-4">About</h5>
                                    <p>Profile page</p>
                                    <h5 class="mt-3 mb-3">Status</h5>
                                    <ul class="user-status p-0">
                                       <li class="mb-1"><i class="ri-checkbox-blank-circle-fill text-success pe-1"></i><span>Online</span></li>                                       
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="chat-searchbar mt-4">
                              <div class="form-group chat-search-data m-0">
                                 <input type="text" class="form-control round" id="chat-search" placeholder="Search">
                                 <i class="ri-search-line"></i>
                              </div>
                           </div>
                        </div>
                        <div class="chat-sidebar-channel scroller mt-4 ps-3">
                           <h5 class="mt-3">Tshats :)</h5>
                           <ul class="iq-chat-ui nav flex-column nav-pills">
                              <li v-for="conv in conversations" :key="conv.id" class="conversation-item" @click="goToChat(conv.otherUser.id)">
                                 <a data-bs-toggle="pill" :href="'/chats/'+conv.otherUser.id">
                                    <div class="d-flex align-items-center">
                                       <div class="avatar me-2">
                                          <img :src="conv.otherUser.avatar" :alt="conv.otherUser.name" class="avatar-50">
                                          <span class="avatar-status"><i class="ri-checkbox-blank-circle-fill text-dark"></i></span>
                                       </div>
                                       <div class="chat-sidebar-name">
                                          <h6 class="mb-0">{{ conv.otherUser.name }}</h6>
                                          <span>translation by</span>
                                       </div>
                                    </div>
                                 </a>
                              </li>                              
                           </ul>
                        </div>
                     </div>
                     <div class="col-lg-9 chat-data p-0 chat-data-right">
                        <div class="tab-content">
                           <div class="tab-pane fade active show" id="chatbox1" role="tabpanel">
                              <div class="chat-head">
                                 <header class="d-flex justify-content-between align-items-center bg-white pt-3 pe-3 pb-3">
                                    <div class="d-flex align-items-center">
                                       <div class="sidebar-toggle">
                                          <i class="ri-menu-3-line"></i>
                                       </div>
                                       <div class="avatar chat-user-profile m-0 me-3">
                                          
                                             <img :src="'https://tshaku.com/'+page_avatar" alt="avatar" class="avatar-50 ">
                                          
                                          <span class="avatar-status"><i class="ri-checkbox-blank-circle-fill text-success"></i></span>
                                       </div>
                                       <h5 class="mb-0">{{page_title}}</h5>
                                    </div>
                                    <div class="chat-user-detail-popup scroller">
                                       <div class="user-profile">
                                          <button type="submit" class="close-popup p-3"><i class="ri-close-fill"></i></button>
                                          <div class="user mb-4  text-center">
                                             <div style="max-height:500px;overflow:hidden;">
                                                <a :href="'/profile/'+page_inshuti_id" class="avatar m-0">
                                                   <img :src="'https://tshaku.com/'+page_avatar" alt="avatar" style="width:100%;">
                                                </a>
                                             </div>
                                             <div class="user-name mt-4">
                                                <h4>{{page_title}}</h4>
                                             </div>
                                             <div class="user-desc">
                                                <p>{{page_location}}</p>
                                             </div>
                                          </div>
                                          <hr>
                                          
                                       </div>
                                    </div>
                                    <div class="chat-header-icons d-flex">
                                       <a href="#" class="chat-icon-phone bg-soft-primary">
                                       <i class="ri-phone-line"></i>
                                       </a>
                                       <a href="#" class="chat-icon-video bg-soft-primary">
                                       <i class="ri-vidicon-line"></i>
                                       </a>
                                       <a href="#" class="chat-icon-delete bg-soft-primary">
                                       <i class="ri-delete-bin-line"></i>
                                       </a>
                                       <span class="dropdown bg-soft-primary">
                                          <i class="ri-more-2-line cursor-pointer dropdown-toggle nav-hide-arrow cursor-pointer pe-0" id="dropdownMenuButton02" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" role="menu"></i>
                                          <span class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton02">
                                             <a class="dropdown-item" href="#"><i class="ri-pushpin-2-line me-1 h5"></i>Pin to top</a>
                                             <a class="dropdown-item" href="#"><i class="ri-delete-bin-6-line me-1 h5"></i>Delete chat</a>
                                             <a class="dropdown-item" href="#"><i class="ri-time-line me-1 h5"></i>Block</a>
                                          </span>
                                       </span>
                                    </div>
                                 </header>
                              </div>
                              <div class="chat-content scroller" id="message-box" style="flex-direction: column;">                                                                     
                                    <div v-for="msg in messages" :key="msg.id" :class="['message', { 'from-me': msg.uid === id, 'from-them': msg.uid !== id }]">
                                       <div v-if="msg.image">
                                          <img :src="msg.image" @click="openImageModal(msg.image)" class="chat-message-image cursor-pointer max-w-xs rounded shadow hover:opacity-80 transition" style="max-width:30%;cursor:pointer;"/>
                                       </div>
                                       <div v-else>
                                          <strong>{{ msg.user }}:</strong> {{ msg.text }}
                                       </div>                                                                               
                                    </div>        
                                    <div v-if="isTyping" class="typing">{{page_firstName}} is typing...</div>                            
                                    <div ref="bottomMarker"></div>
                              </div>                                                            
                              <div class="chat-footer p-3 bg-white">
                                 <div class="d-flex align-items-center">
                                    <div class="chat-attagement d-flex">
                                       <a href="#"><i class="far fa-smile pe-3" aria-hidden="true"></i></a>
                                       <a href="#" @click.prevent="triggerFileUpload"><i class="fa fa-paperclip pe-3" aria-hidden="true"></i></a>
                                       <input ref="fileInput" type="file" @change="handleImageUpload" accept="image/*" style="display:none;"/>
                                    </div>                                    
                                    <input type="text" name="message" id="message" class="form-control me-3"  v-model="newMessage" @keyup.enter="sendMessage" placeholder="Type a message...">                                    
                                    <button id="send-message" type="submit" class="btn btn-primary d-flex align-items-center p-2" @click="sendMessage"><i class="far fa-paper-plane" aria-hidden="true"></i><span class="d-none d-lg-block ms-1">Send</span></button>
                                 </div>
                              </div>
                           </div>
                        </div>                        
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <!-- Image Preview Modal -->
   <div v-if="previewImage" class="preview-overlay">
   <div class="preview-content">
      <img :src="previewImage" class="preview-thumbnail" />
      <div v-if="isUploadingImage" class="spinner-overlay">
         <div class="spinner-border text-light" role="status"></div>
      </div>
      <div class="preview-actions">
         <button @click="uploadImageMessage">Send Image</button>
         <button @click="previewImage = null; imageFile = null">Cancel</button>
      </div>
   </div>
   </div>
   <!-- Image Preview Modal -->
   <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
  <div class="image-wrapper" @click.stop>
    <img :src="modalImageUrl" />
    <button @click="closeImageModal" class="close-button">&times;</button>
  </div>
</div>
</div>        
</template>  
<script>
import ContentHeader from './includes/ContentHeader.vue'
import ContentFooter from './includes/ContentFooter.vue'
import { db } from '../firebase'
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import axios from 'axios'
import {
  collection,
  addDoc,
  query,
  orderBy,
  onSnapshot,
  serverTimestamp,
  setDoc,
  doc,
  where,
  getDoc,
  getDocs,
  limit
} from 'firebase/firestore'

export default {
  name: 'Chat',
  data() {
    return {
      page_title: '',
      page_firstName:'',
      page_lastName:'',
      page_avatar: '',
      page_location:'',
      page_inshuti_id:'',
      page_inshuti_kind:'',
      page_inshuti_story:'',
      messages: [],
      newMessage: '',
      unsubscribeMessages: null,
      conversations: [],
      allUsers: [], // Will hold all user info for avatars/names
      previewImage: null,
      imageFile: null,
      isUploadingImage: false,
      showImageModal: false,
      modalImageUrl: null,
      isTyping: false,
      userInput: '',
    }
  },
  components: { ContentHeader, ContentFooter },
  computed: {
    f_name() {
      return this.$store.state.firstName
    },
    l_name() {
      return this.$store.state.lastName
    },
    city(){
      return this.$store.state.city
    },
    id() {
      return this.$store.state.userId
    },
    avatar() {
      return this.$store.state.avatar
    },
  },
  props: ['chatwith', 'handle'],
  watch: {
   id(val) {
    if (val && this.chatwith) this.checkAndSetupChat()
      if (val) this.setupConversations()
   },
   chatwith(val) {
    if (val && this.id) this.checkAndSetupChat()
   },
   messages() {
      this.$nextTick(() => {
        const el = this.$refs.bottomMarker
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' })
        }
      })
   },    
   //id: 'checkAndSetupChat',
  },
  methods: {
   openImageModal(url) {
      this.modalImageUrl = url
      this.showImageModal = true
   },
   closeImageModal() {
      this.showImageModal = false
      this.modalImageUrl = null
   },
    async page_info() {
      if (this.chatwith) {
        const api_link = 'api.php?action=get_page_info&user_id=' + this.chatwith + '&org_id=37'
        const response = await axios.get(api_link, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        const data = response.data
        if (data.response_code === 200) {
          this.page_title = data.page_title
          this.page_avatar = data.page_avatar
          this.page_location=data.page_location
          this.page_inshuti_id=data.page_inshuti_id
          this.page_inshuti_kind=data.page_inshuti_kind
          this.page_inshuti_story=data.page_inshuti_story    
          const fullName=this.page_title
          const parts = fullName.trim().split(" ")
          this.page_firstName = parts[0]
          this.page_lastName = parts.slice(1).join(" ")
          if(this.page_inshuti_kind=='ai'){
            //Let us log her into firestore
            this.saveUserToFirestore()
          } 
          else{
            this.saveUserToFirestore()
          }  
        }
      }
    },
    async saveUserToFirestore() {
      if (!this.page_inshuti_id) return
         try {            
            const userRef = doc(db, 'users', this.page_inshuti_id)
            await setDoc(userRef, {
                firstName: this.page_firstName,
                lastName: this.page_lastName,
                avatar: 'https://tshaku.com/'+this.page_avatar,
                lastLogin: serverTimestamp()
               }, { merge: true }) // Only updates changed fields
         } catch (error) {
               console.error('Error saving user info to Firestore:', error)
         }
   },
    goToChat(id){
      this.$router.push('/chat/'+id)
    },
    checkAndSetupChat() {
      if (!this.id || !this.chatwith) {
         console.log('Waiting for both user ID and chatwith...')
         return
      }
      this.page_info() // still loads info from external API
      // Reset previous listener
      if (this.unsubscribeMessages) this.unsubscribeMessages()
      this.setupRealtimeMessages()
    },
    async handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.imageFile = file;
      this.selectedImage = file;
      const reader = new FileReader();
         reader.onload = (e) => {
         this.previewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async uploadImageMessage() {      
      if (!this.selectedImage){
         
         return;
      } 
      this.isUploadingImage = true;
      try {
         const formData = new FormData();
         formData.append('image', this.selectedImage);
         // Send image to PHP server for Cloudflare R2 upload
         const response = await fetch('https://apps.programage.com/InshutiManager/R2mediaUpload.php', {
            method: 'POST',
            body: formData,
         });
         const result = await response.json();
         if (!result.success) {
            alert('Image upload failed:', result.error);
            return;
         }
         const imageUrl = result.url; // URL returned by PHP after R2 upload
         const chatId = [this.id, this.chatwith].sort().join('_');
         // Send image message to Firestore
         await addDoc(collection(db, 'chats', chatId, 'messages'), {
            image: imageUrl,
            user: this.f_name,
            uid: this.id,
            createdAt: serverTimestamp(),
         });
         // Clear preview
         this.selectedImage = null;
         this.previewImageUrl = null;
         this.previewImage = false
      } catch (error) {
            console.error('Error uploading image message:', error);
      } finally {
         this.isUploadingImage = false;      
      }            
   },
    async sendMessage() {
      if (!this.newMessage.trim()) return

      const chatId = [this.id, this.chatwith].sort().join('_')
      const messageData = {
        text: this.newMessage,
        user: this.f_name,
        uid: this.id,
        createdAt: serverTimestamp(),
      }
      await addDoc(collection(db, 'chats', chatId, 'messages'), messageData)
      let lastMessage = messageData.text
      if(this.page_inshuti_kind=='ai'){         
         this.isTyping = true;
         // Fetch response from OpenAI
         const response = await this.getOpenAIResponse(this.newMessage);
         const aiMessage = {            
            text: response,
            user: this.page_firstName,
            uid: this.page_inshuti_id,
            createdAt: serverTimestamp(),
         };
         // Save AI message to Firestore
         await addDoc(collection(db, 'chats', chatId, 'messages'), aiMessage);
         lastMessage = aiMessage.text
         //this.messages.push(aiMessage);
         this.isTyping = false;
      }
      await setDoc(doc(db, 'conversations', chatId), {
        chatId,
        participants: [this.id, this.chatwith],
        lastMessage: lastMessage,
        lastUpdated: serverTimestamp(),
      })
      this.newMessage = ''
    },
    //For AIS
   async getOpenAIResponse(inputText) {
      const chatId = [this.id, this.chatwith].sort().join('_');
      try {
         // Step 1: Load last 10 messages from Firestore
         const q = query(
            collection(db, 'chats', chatId, 'messages'),
            orderBy('createdAt', 'asc'),
            limit(10)
         );
         const snapshot = await getDocs(q);

         // Step 2: Format messages for OpenAI
         const messageHistory = [];

         // Add system prompt first
         messageHistory.push({
            role: 'system',
            content: `You are ${this.page_firstName}, and you are "${this.page_inshuti_story}" , Never say anything that could reveal that You are an ai and Do not ask what You can do to assist`,
         });
         snapshot.forEach(doc => {
            const msg = doc.data();
            if (!msg.text) return;
            messageHistory.push({
            role: msg.uid === this.id ? 'user' : 'assistant',
            content: msg.text,
            });
         });
         // Add current message
         messageHistory.push({
            role: 'user',
            content: inputText,
         });
         // Step 3: Send to OpenAI (via your proxy)
         const res = await axios.post('https://apps.programage.com/InshutiManager/openai_proxy.php', {
            model: 'gpt-3.5-turbo',
            //model: 'gpt-neo-20b',
            messages: messageHistory,
            temperature: 0.9,
            max_tokens: 200,
         });
         return res.data.choices[0].message.content.trim();
      } catch (error) {
         console.error('Error fetching AI response:', error);
         return "Sorry, I couldn’t think of a reply 😢";
      }
   },

    //END FOR AIS
    triggerFileUpload() {
      this.$refs.fileInput.click()
    },
    setupRealtimeMessages() {
      const chatId = [this.id, this.chatwith].sort().join('_')
      const q = query(collection(db, 'chats', chatId, 'messages'), orderBy('createdAt'))

      this.unsubscribeMessages = onSnapshot(q, (snapshot) => {
        this.messages = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      })
    },
    setupConversations() {
      const q = query(collection(db, 'conversations'), where('participants', 'array-contains', this.id),orderBy('lastUpdated', 'desc'))

      onSnapshot(q, async (snapshot) => {
        const conversationDocs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))

        // Get all unique user IDs
        const userIds = new Set()
        conversationDocs.forEach((conv) => {
          conv.participants.forEach((pid) => {
            if (pid !== this.id) userIds.add(pid)
          })
        })

        // Fetch user info for those IDs
        const users = {}
        for (const uid of userIds) {
          const userDoc = await getDoc(doc(db, 'users', uid))
          if (userDoc.exists()) users[uid] = userDoc.data()
        }

        // Attach user info to conversations
        this.conversations = conversationDocs.map((conv) => {
          const otherId = conv.participants.find((pid) => pid !== this.id)
          const userData = users[otherId] || { firstName: 'Unknown', lastName: '', avatar: '' }
          return {
            ...conv,
            otherUser: {
              id: otherId,
              name: `${userData.firstName} ${userData.lastName}`,
              avatar: userData.avatar,
            },
          }
        })

        this.allUsers = Object.entries(users).map(([id, data]) => ({ id, ...data }))
      })
    },
    handleKeyDown(e) {
      if (e.key === 'Escape') {
         this.closeImageModal()
      }
    },
  },
  mounted() {
   // Set up chat only if both values are ready
   if (this.id && this.chatwith) {
    this.checkAndSetupChat()
    this.setupConversations()
   }
   // Fetch conversations (we'll handle its own userId check inside)
   //this.fetchUserConversations()
   window.addEventListener('keydown', this.handleKeyDown)
  },
  beforeUnmount() {
    if (this.unsubscribeMessages) this.unsubscribeMessages()
    //adsf
    window.removeEventListener('keydown', this.handleKeyDown)
  },
}
</script>

  
  <style scoped>
  .chat-content{
    height: calc(90vh - 11rem);
    text-align:left;
  }
  /*
  .messages {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 10px;
    margin-bottom: 10px;
  }
  */
  .messages {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.message {
  /*max-width: 100%;*/
  padding: 8px 12px;
  border-radius: 12px;
  margin-bottom:10px;
  word-wrap: break-word;
}

.from-me {
  align-self: flex-end;  
  text-align: right;  
}

.from-them {
  align-self: flex-start;
  background-color: #50b5ff;
  text-align: left;
  color:#000;
}
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.preview-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  max-width: 90%;
  max-height: 90%;
}

.preview-thumbnail {
  max-width: 100%;
  max-height: 400px;
  margin-bottom: 15px;
  border-radius: 8px;
}

.preview-actions button {
  margin: 0 10px;
}
.spinner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-modal {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.image-wrapper {
  position: relative;
}

.image-modal img {
  max-width: 100%;
  max-height: 90vh;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.close-button {
  position: absolute;
  top: 16px;
  right: 20px;
  font-size: 32px;
  color: red;
  background: none;
  border: none;
  cursor: pointer;
}

</style>
  